import React from 'react';
import {observer} from 'mobx-react';
import moment, {Moment} from 'moment';
import {DateUtils} from '../../utility/DateUtils';
import {stylesheet} from 'typestyle';
import {Store} from '../../stores/store';
import Modal from '../../Modal';
import {spinner} from '../../styles/style';
import {I18n} from '../../i18n/i18n';
import InsightsTable from './InsightsTable';
import {InsightsTableMode} from '../../stores/InsightsTableStore';

interface InsightsModalCellAttributeDrilldownProps {
    store: Store;
}

@observer
export default class InsightsModalCellAttributeDrilldown extends React.Component<InsightsModalCellAttributeDrilldownProps, any> {
    public closeModal = () => {
        this.props.store.insightsTableStore.closeModal();
    };

    public renderTable() {
        const {loading} = this.props.store.insightsTableStore.insightsTableData;

        if (loading) {
            return <div className={spinner(60)} />;
        }

        return (
            <InsightsTable
                getSelectedChannel={() => this.props.store.channelStore.selectedChannel}
                windowHeight={this.props.store.windowHeight}
                insightsTableStore={this.props.store.insightsTableStore}
            />
        );
    }

    public getColumnNameForAttribute() {
        const {selectorTableStore, insightsTableStore} = this.props.store;
        const sessionModalSetting = insightsTableStore.insightsModalSetting;
        return sessionModalSetting ? selectorTableStore.tableColumns()[sessionModalSetting.secondary].label : '';
    }

    private addDateRangeIfCustom(): string | null {
        const {insightsModalSetting} = this.props.store.insightsTableStore;
        if (!insightsModalSetting) {
            return null;
        }
        const {mainDateRange} = insightsModalSetting;

        const dateHourFormat = (date?: Moment) => (date ? date.format('L') + ' ' + date.format('LT') : 'na');

        if (
            mainDateRange &&
            mainDateRange.startDate &&
            mainDateRange.endDate &&
            DateUtils.dateIsSame(
                mainDateRange.startDate,
                moment(mainDateRange.endDate)
                    .subtract(59, 'minutes')
                    .subtract(59, 'seconds')
            )
        ) {
            const endDate = moment(mainDateRange.endDate).add(1, 'second');
            return `${dateHourFormat(mainDateRange.startDate)} - ${dateHourFormat(endDate)}`;
        }

        return null;
    }

    public render() {
        const {selectorTableStore, insightsTableStore} = this.props.store;

        selectorTableStore.updateTable;

        if (insightsTableStore.insightsModalSetting === null) {
            return null;
        }

        return (
            <Modal
                modalHeader={
                    <h5 className="modal-title">
                        {insightsTableStore.insightsModalSetting.mode === InsightsTableMode.ProductsForSearchTerm ? (
                            <I18n i18nKey="insights:productsForSearchTerm" />
                        ) : (
                            <I18n i18nKey="insights:searchTermsForProduct" />
                        )}
                        &nbsp;
                        <i>&quot;{insightsTableStore.insightsModalSetting.primary}&quot;</i> - [{this.getColumnNameForAttribute()}]{' '}
                        {this.addDateRangeIfCustom()}
                    </h5>
                }
                onModalClose={this.closeModal}
                store={this.props.store}
                modalBody={<div className={modalCss.insightsModal}>{this.renderTable()}</div>}
            />
        );
    }
}

const modalCss = stylesheet({
    insightsModal: {
        height: 'calc(100vh - 160px)',
    },
});



// WEBPACK FOOTER //
// ./src/views/Table/InsightsModalCellAttributeDrilldown.tsx